import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CredentialsService } from '../../modules/auth/services/credentials.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const credentialsService = inject(CredentialsService);

  if (credentialsService.isAuthenticated()) {
    return true;
  } else {
    localStorage.removeItem('auth');
    router.navigate(['/login']);
    return false;
  }
};
